<template>
  <v-app>
    <core-app-bar ref="appBar" />
    <core-drawer />
    <core-notifications />
    <core-view />

    <core-footer />
  </v-app>
</template>

<script>
export default {
  components: {
    CoreDrawer: () => import("@/components/core/Drawer"),
    CoreFooter: () => import("@/components/core/Footer"),
    CoreAppBar: () => import("@/components/core/AppBar"),
    CoreView: () => import("@/components/core/View"),
    CoreNotifications: () => import("./components/core/Notifications"),
  },
  created: function () {
    //
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    if (this.$store.state.admin.connected) {
      if (
        this.$store.state.admin.storeId &&
        this.$store.state.admin.storeId != "0"
      ) {
        this.$store.dispatch("FETCH_STORE").then((data) => {
          require("@/socket");
          this.$socket
            .on("connect", () => {
              console.log("**** Cleed sockets: ***");
              console.log("Successfull Hand Shake");
              console.log("*******");
            })
            .on("error", (err) => {
              console.log("************ Cleed sockets Error: ************");
              console.log(err);
              console.log("************ Error ************");
            });
        });
        //fetch products
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Fetching products",
        });
        this.$store.dispatch("FETCH_PRODUCTS").then(() => {
          this.$store.dispatch("setLoader", {
            showing: false,
            text: "Fetching looks",
          });
        });
        //fetch shopify access infos
        // this.$store.dispatch("setLoader", {
        //   showing: true,
        //   text: "Fetch shopify access infos",
        // });
        // this.$store
        //   .dispatch("FETCH_SHOPIFY_ACCESS_INFOS")
        //   .then(() => {
        //     this.$store.dispatch("setLoader", {
        //       showing: false,
        //     });
        //   })
        //   .catch((err) => {
        //     console.log("store no shopify");
        //     this.$store.dispatch("setLoader", {
        //       showing: false,
        //     });
        //   });
        //check analytics
        this.$store
          .dispatch("ANALYTICS_STORE")
          .then(() => {
            console.log("store with analytics");
          })
          .catch(() => console.log("store without analytics"));
      } else {
        this.$store.dispatch("FETCH_STORE_IDS").then(() => {
          this.$refs.appBar.storeIds = this.$store.state.store.storeIds;
        });
      }
    }
  },
  destroyed() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  methods: {
    onResize() {
      this.$store.state.isMobile = window.innerWidth < 600;
      // console.log("mobile", this.$store.state.isMobile);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Nunito+Sans");

* {
  font-family: "Nunito Sans";
}
</style>
